import { Link } from "@tanstack/react-router";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import logo from "@/assets/logo-podomasso-clinica-podologia-belem.png";
import { Button } from "@/components/ui/button";
import { SITE, whatsappLink } from "@/lib/site";

const NAV = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/servicos", label: "Serviços" },
  { to: "/blog", label: "Blog" },
  { to: "/agendamento", label: "Agendamento" },
  { to: "/contato", label: "Contato" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:h-20 lg:px-8">
        <Link to="/" className="flex items-center gap-2 transition-smooth hover:opacity-80">
          <img
            src={logo}
            alt="Logo Podomasso Clínica de Podologia em Belém do Pará"
            className="h-12 w-auto lg:h-14"
            width={56}
            height={56}
          />
          <div className="hidden flex-col leading-tight sm:flex">
            <span className="font-display text-lg font-bold text-foreground">Podomasso</span>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
              Clínica de Podologia
            </span>
          </div>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeProps={{ className: "text-primary bg-secondary" }}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground/80 transition-smooth hover:bg-secondary hover:text-primary"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={`tel:${SITE.phone}`}
            className="flex items-center gap-2 text-sm font-semibold text-primary"
          >
            <Phone className="h-4 w-4" />
            {SITE.phoneDisplay}
          </a>
          <Button asChild variant="hero" size="default">
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
              Agendar
            </a>
          </Button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center justify-center rounded-md p-2 text-foreground lg:hidden"
          aria-label="Abrir menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-border/40 bg-background lg:hidden">
          <nav className="flex flex-col gap-1 px-4 py-4">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                activeProps={{ className: "text-primary bg-secondary" }}
                className="rounded-md px-3 py-2.5 text-base font-medium text-foreground/80 hover:bg-secondary hover:text-primary"
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-border/40 pt-3">
              <a
                href={`tel:${SITE.phone}`}
                className="flex items-center gap-2 px-3 py-2 text-sm font-semibold text-primary"
              >
                <Phone className="h-4 w-4" /> {SITE.phoneDisplay}
              </a>
              <Button asChild variant="hero">
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer">
                  Agendar pelo WhatsApp
                </a>
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
